import { EventEmitter } from 'emitter';

module.exports = new EventEmitter();